import { useState, useEffect, useContext } from 'react';

import { PracticeReseveContext } from '../PracticeReseveContext';

function PracticeReserveBeforeLesson() {

  const user = useContext(PracticeReseveContext).user;

  return (
    <>
    {(
      user &&
      (
        !user.day_standard ||
        user.day_standard <= 0 ||
        !user.day_basic ||
        user.day_basic <= 0
      )
    ) &&
      <p className="small bold" style={{ color: 'red' }}>
        ※レッスンをまだ開始されていない方は、レッスン開始後にご予約いただきますようお願いいたします。
      </p>
    }
    </>
  );
}
  
export default PracticeReserveBeforeLesson;